import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',

      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(20),

      '& $row + $row': {
        marginTop: '12px',
      },
    },
    row: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'flex-start',
    },
    title: {
      width: '80px',

      fontSize: 'inherit',
      lineHeight: 'inherit',

      color: theme.palette.text.secondary,
      wordBreak: 'break-word',
      whiteSpace: 'pre-line',
      textAlign: 'right',
    },
    content: {
      flex: '1',
      marginLeft: '13px',
      fontSize: 'inherit',
      lineHeight: 'inherit',
    },
  }),
  { name: 'ContentOutline' }
);
